
import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
import * as utils from '@/lib/utils';

export default Vue.extend({
    props: {
        search: {
            type: String,
        },
    },
    components: {},
    data() {
        return {
            filters: {
                group: 'all',
                status: 'all',
            },
            menu: {
                tenants: false,
            },
            filterGroups: {
                tenants: [],
            },
        };
    },
    mounted() {
        this.selectAllTenants();
    },
    computed: {
        ...mapState('employees', ['employees', 'employeesTableLoading']),
        ...mapState('texts', ['employeesDetails']),
        ...mapState('tenants', ['tenants']),
    },
    methods: {
        customFilter(value: any, search: string | null, item: any): boolean {
            const filterName = item.fullName;
            const filterPhone = `+${item.countryCode}${item.phone}`;
            const filterEmail = item.email;
            const filterDate = this.getCreatedTime(item);
            const filterTenant = this.getTenantName(item);

            if (search != null) {
                if (filterName != null && filterName.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
                if (filterPhone != null && filterPhone.includes(search)) {
                    return true;
                }
                if (filterEmail != null && filterEmail.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
                if (filterDate != null && filterDate.includes(search)) {
                    return true;
                }
                if (filterDate != null && filterDate.includes(search)) {
                    return true;
                }
                if (filterTenant != null && filterTenant.toLowerCase().includes(search.toLowerCase())) {
                    return true;
                }
            }
            return false;
        },
        getHeaders() {
            const futureTicketsColumnTitle = `Future ${this.employeesDetails.tabTitle.toLowerCase()}`;
            const usedTicketsColumnTitle = `Used ${this.employeesDetails.tabTitle.toLowerCase()}`;

            const headers = [
                {
                    text: 'Name',
                    value: 'fullName',
                    width: 300,
                },
                {
                    text: 'Email',
                    value: 'email',
                    width: 300,
                },
                {
                    text: 'Phone',
                    value: 'phone',
                    width: 150,
                    sortable: false,
                },
                {
                    text: 'Status',
                    value: 'status',
                    width: 120,
                    filter: (value: string): boolean => {
                        if (this.filters.status === 'all') return true;
                        return value === this.filters.status;
                    },
                },
                {
                    text: 'Group',
                    value: 'group',
                    width: 120,
                    filter: (value: string): boolean => {
                        if (this.filters.group === 'all') return true;
                        if (value === null && this.filters.group === 'regular') return true;
                        return value === this.filters.group;
                    },
                },
                {
                    text: futureTicketsColumnTitle,
                    value: 'features.upcoming_tickets',
                    width: 140,
                },
                {
                    text: usedTicketsColumnTitle,
                    value: 'features.used_tickets',
                    width: 125,
                },
                {
                    text: 'Cancellations',
                    value: 'features.canceled_tickets',
                    width: 135,
                },
                {
                    text: 'No shows',
                    value: 'features.expired_tickets',
                    width: 110,
                },
                {
                    text: 'Last used',
                    value: 'features.last_ticket_date',
                    width: 110,
                },
                {
                    text: 'Created',
                    value: 'created',
                    width: 110,
                },
            ];

            if (this.tenants.length > 0) {
                // insert tenant column right after the Email column
                const fieldIndex = headers.findIndex((h) => h.text === 'Email');
                headers.splice(fieldIndex + 1, 0, {
                    text: 'Tenant',
                    value: 'tenantId',
                    width: 300,
                    filter: (value: string): boolean => this.filterGroups.tenants.includes(value as never),
                });
            }

            return headers;
        },
        onRowSelect(row: any, rowDetails: any) {
            this.$router.push(`/employees/${row.userId}/details`);
        },
        getAvatar(): string {
            return require('../../assets/avatars/default.jpg');
        },
        getCreatedTime(item: any): string {
            return item.created ? utils.convertDateToAmericanFormat(item.created) : '';
        },
        getLastUsed(item: any): string {
            return item.features?.last_ticket_date ? utils.convertDateToAmericanFormat(item.features?.last_ticket_date) : '';
        },
        getNoShowsCount(item: any): number {
            return item.features?.expired_tickets || 0;
        },
        getCancellationsCount(item: any): number {
            return item.features?.canceled_tickets || 0;
        },
        getFutureTicketsCount(item: any): number {
            return item.features?.upcoming_tickets || 0;
        },
        getUsedTicketsCount(item: any): number {
            return item.features?.used_tickets || 0;
        },
        getTenantName(item: any): string {
            const tenant = this.tenants.find((t: any) => t.tenantId === item?.tenantId);
            return tenant ? tenant.firmName : null;
        },
        getTenantsList() {
            const list = this.tenants.map((t: any) => ({ key: t.tenantId, value: t.firmName }));
            return list;
        },
        selectAllTenants() {
            this.filterGroups.tenants = this.getTenantsList().map((t: any) => t.key);
        },
    },
});
